import React from 'react';
import { useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import NavMenuItem from './NavMenuItem';

const normalizeRole = (role) => String(role == null ? '' : role).toLowerCase().replace(/[^a-z0-9]/g, '');

function getUserRoles() {
  const roles = new Set();
  ['access', 'role', 'userRole', 'user_role', 'roles', 'userRoles', 'user_roles', 'currentRole', 'currentUserRole']
    .forEach((key) => {
      const raw = localStorage.getItem(key);
      if (!raw) return;
      raw.split(/[;,]/).map(normalizeRole).filter(Boolean).forEach((role) => roles.add(role));
      try {
        const parsed = JSON.parse(raw);
        if (Array.isArray(parsed)) parsed.forEach((role) => roles.add(normalizeRole(role)));
      } catch (_) {
        // A plain role string is also a valid value.
      }
    });
  return roles;
}

function isMenuVisibleForRoles(menuItem, userRoles) {
  if (!menuItem) return false;
  if (!Array.isArray(menuItem.roles) || menuItem.roles.length === 0) return true;
  return menuItem.roles.some((role) => userRoles.has(normalizeRole(role)));
}

function SidebarContent() {
  const sidebar = useSelector((state) => state.sidebar);
  const { sidebarMenus } = sidebar || {};
  const userRoles = getUserRoles();
  const categories = Array.isArray(sidebarMenus?.category1) ? sidebarMenus.category1 : [];

  const filteredCategories = categories
    .map((category) => ({
      ...category,
      child_routes: Array.isArray(category.child_routes)
        ? category.child_routes.filter((child) => isMenuVisibleForRoles(child, userRoles))
        : category.child_routes,
    }))
    .filter((category) => !Array.isArray(category.child_routes) || category.child_routes.length > 0);

  return (
    <div className="rct-sidebar-nav hr-main-nav">
      {filteredCategories.map((menu) => <NavMenuItem menu={menu} key={menu.menu_title} />)}
    </div>
  );
}

export default withRouter(SidebarContent);
